import React from 'react';
import Checkbox from '../../Checkbox/Checkbox';
import './Answer.css';

function Answer({answer, onClick}) {
    const handleClick = () => {
        if (!answer) return;
        if (onClick) onClick(answer.id);
    };

    return (
        <div className='answer' onClick={handleClick}>
            <div className='answer_label'>{answer.label || 'Sin descripción'}</div>
            <div className='answer_checkbox'>
                <Checkbox selected={answer.selected} onClick={undefined}/>
            </div>
        </div>
    );
}

export default Answer;